import Header from "@domains/useCases/Header";
import Footer from "@domains/useCases/Footer";
import StreamUseCase from "@domains/useCases/StreamUsecase";
import NewsStreamUseCase from "@domains/useCases/NewsStreamUseCase";
import ShareWebinar from "@domains/useCases/webinar/ShareWebinar";
import RegistrationWebinar from "@domains/useCases/webinar/RegistrationWebinar";
import FeedbackUseCase from "@domains/useCases/feedback/feedback";
import exchangeHolidaysUseCase from "@domains/useCases/StaticFooter/exchangeHolidaysUseCase";
import CircularUpdateUseCase from "@domains/useCases/StaticFooter/circularUpdateUseCase";
import ScripDetailUseCase from "@domains/useCases/Common/ScripDetailUseCase";
import LocateUsUseCase from "@domains/useCases/StaticFooter/locateusUseCase";
import customConfigUseCase from "@domains/useCases/Common/customConfig";
import { FaqUseCase } from "@domains/useCases/StaticFooter/faqUseCase";
import LiveNewsUseCases from "@domains/features/LiveNews/useCases/LiveNewsUseCase";
import EquityHoldingLiveNewsUseCase from "@domains/features/LiveNews/useCases/EquityHoldingLiveNews";
import MarketDataUseCase from "@domains/useCases/MarketDataUseCases";
import EvotingUseCase from "@domains/useCases/Evoting";
import AdBlockUseCase from "../../../domains/useCases/Home/AdBlockUseCase";
import InvestorUseCase from "../../../domains/useCases/Home/InvestorUseCase";
import MarketNewsUseCase from "../../../domains/useCases/Home/MarketNewsUseCase";
import WebinarUseCase from "../../../domains/useCases/Home/WebinarUseCase";
import NewOnEdelUseCase from "../../../domains/useCases/Home/NewOnEdelUseCase";
import OfferingsUseCase from "../../../domains/useCases/Home/OfferingsUseCase";
import MarketDepthStreamUseCase from "@domains/useCases/MarketDepthStreamUseCase";
import VerifyMsLoginUseCase from "@domains/useCases/Common/MsLoginUseCase";
import PortalAccessLoginUseCase from "@domains/useCases/Common/portalAccessLogin";
import PortalAccessOtpValidateUseCase from "@domains/useCases/Common/portalAccessOtpVerification";
import PortalAccessResendOtpUseCase from "@domains/useCases/Common/portalAccessResendOtp";
export default (function (repositories) {
    return {
        header: {
            getMenuData: new Header(repositories.header),
            getMarketData: new MarketDataUseCase(repositories.header),
            handleEVoting: new EvotingUseCase(repositories.header),
        },
        home: {
            adBlock: new AdBlockUseCase(repositories.home),
            investor: new InvestorUseCase(repositories.home),
            marketNews: new MarketNewsUseCase(repositories.home),
            webinar: new WebinarUseCase(repositories.home),
            newOnEdel: new NewOnEdelUseCase(repositories.home),
            offerings: new OfferingsUseCase(repositories.home),
        },
        footer: {
            footer: new Footer(repositories.footer),
            staticFooter: {
                exchangeHolidays: new exchangeHolidaysUseCase(repositories.footer),
                circularUpdate: new CircularUpdateUseCase(repositories.footer),
                locateus: new LocateUsUseCase(repositories.footer),
                faqlist: new FaqUseCase(repositories.footer),
            },
        },
        quoteStream: new StreamUseCase(repositories.quoteStream),
        shareWebinar: new ShareWebinar(repositories.webinarShare),
        registrationWebinar: new RegistrationWebinar(repositories.webinarShare),
        feedback: new FeedbackUseCase(repositories.feedback),
        common: {
            scripDetail: new ScripDetailUseCase(repositories.common),
            customConfig: new customConfigUseCase(repositories.common),
            verifyMsLogin: new VerifyMsLoginUseCase(repositories.common),
            portalAccessLogin: new PortalAccessLoginUseCase(repositories.common),
            portalAccessOtpValidate: new PortalAccessOtpValidateUseCase(repositories.common),
            portalAccessResendOtp: new PortalAccessResendOtpUseCase(repositories.common),
        },
        newsStream: new NewsStreamUseCase(repositories.newsStream),
        liveNews: {
            liveNews: new LiveNewsUseCases(repositories.liveNews),
            equityHoldingLiveNews: new EquityHoldingLiveNewsUseCase(repositories.liveNews),
        },
        marketDepthStream: new MarketDepthStreamUseCase(repositories.marketDepthStream),
    };
});
